import { Routes, Route, useParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AdminShell from "@/components/shared/AdminShell";
import VisionLogo from "@/components/shared/VisionLogo";
import {
  Receipt, LayoutDashboard, Boxes, ShoppingCart, ShoppingBag, Users,
  UserPlus, Megaphone, LineChart, Wallet, CreditCard, Settings, Store,
} from "lucide-react";
import POS from "@/pages/store/POS";
import StoreDashboard from "@/pages/store/StoreDashboard";
import StoreStock from "@/pages/store/StoreStock";
import StoreSales from "@/pages/store/StoreSales";
import StoreOrders from "@/pages/store/StoreOrders";
import StoreCRM from "@/pages/store/StoreCRM";
import StoreAnalytics from "@/pages/store/StoreAnalytics";
import StoreSettings from "@/pages/store/StoreSettings";
import { Customers, StoreExpenses, StoreTreasury, StoreMarketing, OnlineStore } from "@/pages/store/StoreModules";

const FIN = ["owner", "manager", "super_admin"];

function Fin({ user, children }) {
  if (user && !FIN.includes(user.role))
    return <div className="text-slate-400 py-10 text-center">Accès réservé à la direction (propriétaire / gérant).</div>;
  return children;
}

export default function StoreApp() {
  const { slug } = useParams();
  const { user } = useAuth();
  const base = `/store/${slug}/admin`;
  const NAV = [
    { to: "", label: "Caisse (POS)", icon: Receipt, end: true },
    { to: "dashboard", label: "Tableau de bord", icon: LayoutDashboard },
    { to: "boutique", label: "Boutique en ligne", icon: Store },
    { to: "stock", label: "Stock", icon: Boxes },
    { to: "ventes", label: "Ventes", icon: ShoppingCart },
    { to: "commandes", label: "Commandes", icon: ShoppingBag },
    { to: "clients", label: "Clients", icon: Users },
    { to: "crm", label: "CRM", icon: UserPlus },
    { to: "marketing", label: "Marketing", icon: Megaphone },
    { to: "analyse", label: "Analyse", icon: LineChart, roles: FIN },
    { to: "tresorerie", label: "Trésorerie", icon: Wallet, roles: FIN },
    { to: "charges", label: "Charges", icon: CreditCard, roles: FIN },
    { to: "parametres", label: "Paramètres", icon: Settings, roles: FIN },
  ];
  const nav = NAV.filter((n) => !n.roles || (user && n.roles.includes(user.role)));
  return (
    <Routes>
      <Route element={<AdminShell brand={<VisionLogo variant="dark" size={28} />} subtitle={`Boutique · ${slug}`} storeName="Back-office boutique" base={base} nav={nav} />}>
        <Route index element={<POS />} />
        <Route path="dashboard" element={<StoreDashboard />} />
        <Route path="boutique" element={<OnlineStore />} />
        <Route path="stock" element={<StoreStock />} />
        <Route path="ventes" element={<StoreSales />} />
        <Route path="commandes" element={<StoreOrders />} />
        <Route path="clients" element={<Customers />} />
        <Route path="crm" element={<StoreCRM />} />
        <Route path="marketing" element={<StoreMarketing />} />
        <Route path="analyse" element={<Fin user={user}><StoreAnalytics /></Fin>} />
        <Route path="tresorerie" element={<Fin user={user}><StoreTreasury /></Fin>} />
        <Route path="charges" element={<Fin user={user}><StoreExpenses /></Fin>} />
        <Route path="parametres" element={<Fin user={user}><StoreSettings /></Fin>} />
      </Route>
    </Routes>
  );
}
